<template>
    <!-- Loader -->
    <LoaderComponent v-model:data="PublicLoaderData" />

    <!-- Content -->
    <router-view v-slot="{ Component }">
        <component v-if="Component" :is="Component" ref="viewRef" @navigation-event="handleNavigationEvent" />
    </router-view>
</template>


<script setup lang="ts">
    import { ref, onMounted, provide, computed } from 'vue'
    import { LoaderComponent } from "nlb-buy-go-library";
    import { commClient } from "fw4-library";
    import { useRoute, useRouter } from 'vue-router';
    import { useLoaderData } from "@/app/store/app/component/loader-component";

    const el = ref();
    const route = useRoute();
    const router = useRouter();
    const { PublicLoaderData } = useLoaderData();

    const handleNavigationEvent = async (action: string, urlParams?: any) => {
        if (action != null && navigation.value[action] != null) {
            await router.push({
                name: navigation.value[action],
                ...(urlParams && { params: urlParams })
            });
        }
    };

    const navigation = computed(() => route.meta.navigation as Record<string, string>);

    onMounted(() => {
        let lpContainer: Element | null = document.querySelector(".LPMcontainer");

        if (lpContainer != null) {
            lpContainer.setAttribute("hidden", "true");
        }
    });
    
    provide("commClient", commClient);
</script>
